/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentSystemSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for System Settings API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:37 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const EmailSettings = {
    get: () => requests.get('/EmailSettings'),
    create: emailsettings => requests.post('/EmailSettings', emailsettings),
    update: emailsettings => requests.put('/EmailSettings', emailsettings),
    delete: () => requests.del('/EmailSettings'),
};


// WEBPACK FOOTER //
// ./src/agents/agentSystemSettings.js